module.exports = __webpack_public_path__ + "media/images/caret-left-7bdcfe33d7450feaa8b947ec1170de0c.svg";